import {ApplicationRef, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {window} from 'rxjs';

@Component({
  selector: 'app-web-viewer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './web-viewer.component.html',
  styleUrls: ['./web-viewer.component.scss']
})
export class WebViewerComponent {
  get url(): any {
    return this._url;
  }
  @Input()
  set url(value: any) {
    this._url = value;
    this.prepareUrl()
  }
  private _url!: any;

  safeUrl: SafeResourceUrl | null = null;
  invalidReason: string | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  private prepareUrl() {
    // For iframe src we must use a SafeResourceUrl
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url.toString());
  }
}
